import { render } from "./ImagePopup.vue?vue&type=template&id=4e8f7a46&scoped=true&ts=true&lang=pug"
import script from "./ImagePopup.vue?vue&type=script&lang=ts"
export * from "./ImagePopup.vue?vue&type=script&lang=ts"

import "./ImagePopup.vue?vue&type=style&index=0&id=4e8f7a46&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8f7a46"]])

export default __exports__